//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deviation', {
//        templateUrl: 'views/components/views/deviation/deviation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'utilityService', 'translateService', 'deviationService', 'deviationTypesService', 'economyService', 'rememberService', function ($stateParams, stateService, modalService, utilityService, translateService, deviationService, deviationTypesService, economyService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let custactNoDeviation = $stateParams.custact_no_deviation;

//            let variableNames = {
//                activitytype_no: ''
//            };

//            let translations = {
//                confirm: '',
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                custactNoDeviation: custactNoDeviation,
//                edit: {},
//                selectListOnlyDeviations: [],
//                selectListDeviationTypes: [],
//                selectListOrderLines: [],
//                selectListActivityStatuses: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await deviationService.getEdit({
//                    argtype: argType,
//                    argvalue: argValue,
//                    custact_no_deviation: custactNoDeviation
//                }))[0];
//            }

//            async function loadOnlyDeviations() {
//                vm.model.selectListOnlyDeviations = await deviationService.listOnlyDeviations();
//            }

//            async function loadDeviationTypes() {
//                if (utilityService.validateParmsValue(vm.model.edit.activitytype_no) !== true) return;
                
//                if (vm.model.edit.isnew === '1') {
//                    return vm.model.selectListDeviationTypes = await deviationTypesService.listDeviationTypes({
//                        isactive: '1',
//                        activitytype_no: vm.model.edit.activitytype_no
//                    });
//                } else if (vm.model.edit.isnew === '0') {
//                    return vm.model.selectListDeviationTypes = await deviationTypesService.listDeviationTypes({
//                        isactive: 'ALL',
//                        activitytype_no: vm.model.edit.activitytype_no
//                    });
//                }
//            }

//            async function loadOrderLines() {
//                if (utilityService.validateParmsValue(vm.model.edit.argtype) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.argvalue) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.custact_no_deviation) !== true) return;

//                return vm.model.selectListOrderLines = await deviationService.listOrderLines({
//                    argtype: vm.model.edit.argtype,
//                    argvalue: vm.model.edit.argvalue,
//                    custact_no_deviation: vm.model.edit.custact_no_deviation
//                });
//            }

//            async function loadActivityStatuses() {
//                if (utilityService.validateParmsValue(vm.model.edit.activitytype_no) !== true) return;
                
//                return vm.model.selectListActivityStatuses = await economyService.listActivityStatuses({ activitytype_no: vm.model.edit.activitytype_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'activitytype_no':
//                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

//                        variableValue = vm.model.edit[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            function saveDeviation() {
//                deviationService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].ws_result !== '1') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].ws_result_message,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                }
//                            }]
//                        });
//                    }
//                });
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deviationService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].ws_result === '1') {
//                        modalService.show({
//                            type: 'success',
//                            title: translations.confirm,
//                            message: response[0].ws_result_message,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-success',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                                }
//                            }]
//                        });
//                    } else {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                            message: response[0].ws_result_message,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'workdetails':
//                        Promise.all([
//                            saveDeviation()
//                        ]).then(() => {
//                            go({ custact_no: vm.model.edit.custact_no_deviation });
//                            Promise.resolve();
//                        });

//                        break;
//                    case 'pictures':
//                    case 'checklistdatas':
//                        Promise.all([
//                            saveDeviation()
//                        ]).then(() => {
//                            go({
//                                argtype: 'custact_no',
//                                argvalue: vm.model.edit.custact_no_deviation
//                            });

//                            Promise.resolve();
//                        });

//                        break;
//                    case 'documents':
//                        Promise.all([
//                            saveDeviation()
//                        ]).then(() => {
//                            go({
//                                argtype: 'custact_no',
//                                argvalue: vm.model.edit.custact_no
//                            });

//                            Promise.resolve();
//                        });

//                        break;
//                    case 'selectreport':
//                        deviationService.saveObj(vm.model.edit).then(function (response) {
//                            if (response[0].ws_result !== '1') {
//                                modalService.show({
//                                    type: 'warning',
//                                    title: translations.error,
//                                    message: response[0].ws_result_message,
//                                    buttons: [{
//                                        label: translations.ok,
//                                        cssClass: 'btn-warning',
//                                        action: function (dialogItself) {
//                                            dialogItself.close();
//                                        }
//                                    }]
//                                });
//                            } else {
//                                go({
//                                    webpage_name: stateService.getCurrentName(),
//                                    argtype: 'custact_no',
//                                    argvalue: vm.model.edit.custact_no
//                                });
//                            }
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL
            
//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    deviationService.deleteItem({ custact_no: vm.model.edit.custact_no_deviation }).then(() => {
//                    	vm.model.lockedDelete = false;
//                    	stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'activitytype_no':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.activitytype_no) !== true) return;

//                        vm.model.edit.activitytype_no = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.activitytype_no) !== true) return;

//                        Promise.all([
//                            rememberFunc('activitytype_no')
//                        ]).then(() => {
//                            loadDeviationTypes();
//                            loadActivityStatuses();
//                            Promise.resolve();
//                        });

//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadOnlyDeviations();
//                loadDeviationTypes();
//                loadOrderLines();
//                loadActivityStatuses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
